import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as FieldActivityActions from '../_actions/fieldActivity';
import { FieldActivity } from '../_models';

export interface FieldActivityState extends EntityState<FieldActivity> {
  loading: boolean;
  loaded: boolean;
  error: any;
}

export const adapter: EntityAdapter<FieldActivity> = createEntityAdapter<FieldActivity>();

const initialState: FieldActivityState = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

const FieldActivityReducer = createReducer(
  initialState,

  on(FieldActivityActions.loadFieldActivities, (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
  })),

  on(FieldActivityActions.loadFieldActivitiesSuccess, (state, { fieldActivities }) =>
    adapter.setAll(fieldActivities, { ...state, loaded: true, loading: false })
  ),

  on(FieldActivityActions.loadFieldActivitiesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(FieldActivityActions.addFieldActivitySuccess, (state, { fieldActivity }) =>
    adapter.addOne(fieldActivity, state)
  ),

  on(FieldActivityActions.updateFieldActivitySuccess, (state, { fieldActivity }) =>
    adapter.upsertOne(fieldActivity, state)
  ),

  on(FieldActivityActions.deleteFieldActivitySuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    FieldActivityActions.addFieldActivityFailure,
    FieldActivityActions.updateFieldActivityFailure,
    FieldActivityActions.deleteFieldActivityFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: FieldActivityState | undefined, action: Action) {
  return FieldActivityReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
